const MAX_VIOLATED_WORDS_COUNT = 10;

const DIAGEO_VIOLATED_WORDS = [
  `Newborn`,
  `Preschool`,
  `Bedtime`,
  `Storytime`,
  `Swaddle`,
  `Crib`,
  `Bib`,
  `Teether`,
  `Diapers`,
  `Potty`,
  `Midwife`,
  `Doulas`,
  `Nursery`,
  `Breastpump`,
  `Bottlefeed`,
  `Highchair`,
  `Playpen`,
  `Carseat`,
  `Onesie`,
  `Politics`,
  `President`,
  `Government`,
  `Elections`,
  `Parliament`,
  `Law`,
  `Court`,
  `Constitution`,
  `Deputy`,
  `Minister`,
  `Corruption`,
  `Opposition`,
  `Democracy`,
  `Voting`,
  `Sanctions`,
  `Civil rights`,
  `Political party`,
  `Legislation`,
  `Governance`,
  `Prime Minister`,
  `Senator`,
  `Congress`,
  `Judiciary`,
  `Legal system`,
  `Cabinet`,
  `Diplomatic`,
  `Referendum`,
  `Bureaucracy`,
  `Policy`,
  `Protest`,
  `Rally`,
  `State affairs`,
  `Dictatorship`,
  `Autocracy`,
  `Communism`,
  `Capitalism`,
  `Public sector`,
  `Federal`,
  `Lobbying`,
  `Political debate`,
  `Taxation`,
  `Immigration policy`,
  `Public administration`,
  `Donald Trump`,
  `Trump`,
  `Volodymyr Zelenskyy`,
  `Zelenskyy`,
  `William Ruto`,
  `Ruto`,
  `Vladimir Putin`,
  `Putin`,
  `Raila Odinga`,
  `Raila`,
  `Rigathi Gachagua`,
  `IEBC`,
  `Supreme Court`,
  `High Court`,
  `Chief Justice`,
  `Martha Koome`,
  `Ahmednassir`,
  `Neslon Havi`,
  `Senate`,
  `MPs`,
  `Neslon Havi`,
  `National Assembly`,
  `Parliament`,
  `Edwin Sifuna`,
  `Kalonzo Musyoka`,
  `Ndindi Nyoro`,
  `Kalonzo Musyoka`,
  `Martha Karua`,
  `Eugine Wamalwa`,
  `George Natembeya`,
  `Mt Kenya`,
  `Senator Onyonka`,
  `Kimani Ichungwah`,
  `Wamatangi`,
  `Senator Methu`,
  `Musalia Mudavadi`,
  `Moses Wetangula`,
  `Speaker`,
  `Amason Kingi`,
  `David Maraga`,
  `Samson Cherargei`,
  `IG Kanja`,
  `Kithure Kindiki`,
  `Raymond Omolo`,
  `Amendment`,
  `Impeachment`,
  `ODM`,
  `UDA`,
  `Kenya Kwanza`,
  `Broad-based`,
  `NADCO report`,
  `Moses Kuria`,
  `Yoweri Museveni`,
  `Kizza Bisigye`,
  `Bobi Wine`,
  `Samia Suluhu`,
  `Uganda`,
  `Tanzania`,
  `DRC`,
  `Felix Tsishekedi`,
  `South Sudan`,
  `Sudan`,
  `RFS`,
  `Ministry of Foreign Affairs`,
  `Wiper party`,
  `Wajackoyah`,
  `Crime`,
  `Criminal`,
  `Murder`,
  `Violence`,
  `Arrest`,
  `Criminal record`,
  `Theft`,
  `Robbery`,
  `Terrorism`,
  `Assault`,
  `Corruption`,
  `Imprisonment`,
  `Mafia`,
  `Smuggling`,
  `Fraud`,
  `Kidnapping`,
  `Drug trafficking`,
  `Human trafficking`,
  `Ransom`,
  `Gang`,
  `Bribery`,
  `Forgery`,
  `Cybercrime`,
  `Blackmail`,
  `Extortion`,
  `Sexual assault`,
  `Domestic violence`,
  `Hit and run`,
  `Money laundering`,
  `Homicide`,
  `Vandalism`,
  `Trespassing`,
  `Organized crime`,
  `Stalking`,
  `Carjacking`,
  `Identity theft`,
  `Narcotics`,
  `Drug cartel`,
  `Law enforcement`,
  `Investigation`,
  `Interrogation`,
  `Abduction`,
  `Jailed`,
  `Detained`,
  `Sentencing`,
  `Police`,
  `DCI`,
  `NPS`,
  `Charged`,
  `Arraignment`,
  `Convict`,
  `Imprisonment`,
  `Judgment`,
  `Suspect`,
  `Violence`,
  `Fight`,
  `Murder`,
  `Terrorism`,
  `Explosion`,
  `Weapon`,
  `Attack`,
  `Brutality`,
  `Injury`,
  `Threat`,
  `War`,
  `Beating`,
  `Aggression`,
  `Riot`,
  `Shooting`,
  `Stabbing`,
  `Torture`,
  `Domestic abuse`,
  `Street fight`,
  `Hostage`,
  `Armed robbery`,
  `Gang violence`,
  `Conflict`,
  `Massacre`,
  `Suicide bombing`,
  `Military strike`,
  `Bloodshed`,
  `Genocide`,
  `Lynching`,
  `Hate crime`,
  `Execution`,
  `Honor killing`,
  `Human rights abuse`,
  `Brutal force`,
  `Robbing`,
  `Gun`,
  `Firearm`,
  `Deportation`,
  `Smuggling`,
  `Bibery`,
  `Overlapping`,
  `Overspeeding`,
  `Traffic offenses`,
  `Head-on collision`,
  `Blows, kicks and slaps`,
  `Stranggling`,
  `Postmorterm`,
  `Education`,
  `University`,
  `College`,
  `School`,
  `Studying`,
  `Student`,
  `Teacher`,
  `Classroom`,
  `Lecture`,
  `Diploma`,
  `Grades`,
  `Exam`,
  `Academy`,
  `Tutor`,
  `Training`,
  `Syllabus`,
  `Curriculum`,
  `Faculty`,
  `Scholarship`,
  `Admissions`,
  `Homework`,
  `Research`,
  `Textbook`,
  `Degree`,
  `Pedagogy`,
  `E-learning`,
  `Professor`,
  `Essay`,
  `Dissertation`,
  `Internship`,
  `Learning disabilities`,
  `Special education`,
  `Tuition fees`,
  `Student debt`,
  `Board exam`,
  `Classroom management`,
  `Career counseling`,
  `Educational policy`,
  `Homeschooling`,
  `Online courses`,
  `University ranking`,
  `Results`,
  `Marks',
  'Grades`,
  `School fees`,
  `Student protests`,
  `Teachers protests`,
  `Lecturers protests`,
  `Funding model`,
  `HELB loan`,
  `Education ministry`,
  `KNEC`,
  `KCSE`,
  `KCPE`,
  `KEPSHA`,
  `TSC`,
  `KNUT`,
  `KUPPET`,
  `JSS`,
  `Strike`,
  `CS Ogamba`,
  `Education CS`,
  `Education PS`,
  `Belio Kipsang`,
  `Nancy Macharia`,
  `Moi University`,
  `UON`,
  `KU`,
  `JKUAT`,
  `MKU`,
  `Library`,
  `Certificate`,
  `PhD`,
  `Masters`,
  `Tuition block`,
  `Capitation fund`,
  `University of Nairobi`,
  `Candidate`,
  `Pupil`,
  `Chalkboard`,
  `Technical University of Kenya`,
  `University of Eldoret`,
  `Health`,
  `Fitness`,
  `Disease`,
  `Treatment`,
  `Diet`,
  `Workout`,
  `Virus`,
  `Flu`,
  `Doctor`,
  `Pharmacy`,
  `Symptoms`,
  `Vaccine`,
  `Immunity`,
  `Cardiology`,
  `Oncology`,
  `Surgery`,
  `Mental health`,
  `Depression`,
  `Anxiety`,
  `Therapy`,
  `Meditation`,
  `Gym`,
  `Nutrition`,
  `Weight loss`,
  `Obesity`,
  `Healthcare system`,
  `Prescription drugs`,
  `Epidemic`,
  `Pandemic`,
  `Public health`,
  `Heart disease`,
  `Diabetes`,
  `Cholesterol`,
  `Blood pressure`,
  `Arthritis`,
  `Cancer`,
  `Rehabilitation`,
  `Physical therapy`,
  `Sleep disorder`,
  `Hormonal imbalance`,
  `Detox`,
  `Immune system`,
  `Wellness`,
  `Aerobics`,
  `Medication`,
  `Heart rate`,
  `Self care`,
  `Hormonal imbalance`,
  `Fasting`,
  `Vitamins`,
  `Carbohydrates`,
  `Proteins`,
  `Yoga`,
  `Fitness trainer`,
  `Chronic illness`,
  `Cancer`,
  `Asphyxiation`,
  `Supplements`,
  `Hydration`,
  `Fruits`,
  `Calories`,
  `Deaf`,
  `Down's Syndrome`,
  `Audiology`,
  `Physically impaired`,
  `Wheelchair`,
  `Living With Disability`,
  `Malnutrition`,
  `Exercise`,
  `Kenyatta National Hospital`,
  `Doctor`,
  `Physician`,
  `Clinical Officer`,
  `Medical Intern`,
  `Mama Lucy Kibaki Hospital`,
  `Medical Superintendent`,
  `Kenya Medical Training College`,
  `Cerebral Palsy`,
  `Gynaecologist`,
  `Ambulance`,
  `Parents`,
  `Children`,
  `Pregnancy`,
  `Childbirth`,
  `Motherhood`,
  `Father`,
  `Mother`,
  `Parenting`,
  `Baby`,
  `Teenager`,
  `Parenting school`,
  `Adoption`,
  `Marriage`,
  `Divorce`,
  `Infant`,
  `Toddler`,
  `Child development`,
  `Breastfeeding`,
  `Maternity`,
  `Paternity`,
  `Baby care`,
  `Babysitter`,
  `Parenting tips`,
  `Family planning`,
  `Fertility`,
  `Single parent`,
  `Step-parent`,
  `Custody`,
  `Child support`,
  `Domestic life`,
  `Work-life balance`,
  `Co-parenting`,
  `Parenting stress`,
  `Child psychology`,
  `Playtime`,
  `Family therapy`,
  `Sibling rivalry`,
  `Home education`,
  `Twins`,
  `Triplets`,
  `Quadruplets`,
  `Caesarian Section`,
  `Daughter`,
  `Son`,
  `Guardian`,
  `Foster Care`,
  `Nanny`,
  `Childhood`,
  `Disclipline`,
  `Grandma`,
  `Grandpa`,
  `Household Chores`,
  `Immunization`,
  `Tantrums`,
  `Daycare`,
  `Pacifier`,
  `Weaning`,
  `Craddle`,
  `Role model`,
  `School fees`,
  `House rules`,
  `Bedwetting`,
  `Crawling`,
  `Still birth`,
  `Potty training`,
  `Godparent`,
  `Baby seat`,
  `Stroller`,
  `Shawl`,
  `Playgroup`,
  `Minecraft`,
  `School uniform`,
  `Mittens`,
  `Conceived`,
  `Paedophile`,
  `Teething`,
  `Adolescence`,
  `Paeditrician`,
  `Babyproofing`,
  `Burping`,
  `Religion`,
  `God`,
  `Church`,
  `Islam`,
  `Christianity`,
  `Buddhism`,
  `Prayer`,
  `Cross`,
  `Quran`,
  `Bible`,
  `Prophet`,
  `Allah`,
  `Priest`,
  `Pilgrimage`,
  `Temple`,
  `Mosque`,
  `Synagogue`,
  `Hinduism`,
  `Sikhism`,
  `Atheism`,
  `Spirituality`,
  `Meditation`,
  `Faith`,
  `Worship`,
  `Clergy`,
  `Sermon`,
  `Religious ritual`,
  `Monastery`,
  `Evangelism`,
  `Gospel`,
  `Theology`,
  `Holy book`,
  `Divine intervention`,
  `Fasting`,
  `Conversion`,
  `Religious freedom`,
  `Sacred texts`,
  `Martyr`,
  `Exorcism`,
  `Herbalist`,
  `Pastor`,
  `Exorcism`,
  `Prophetess`,
  `Tithe`,
  `Offering`,
  `Vigil`,
  `Kesha`,
  `Miracle`,
  `Annointing oil`,
  `Deacon`,
  `Illuminati`,
  `Deity`,
  `Sect`,
  `Cult`,
  `Robe`,
  `Pope`,
  `Lent`,
  `Messiah`,
  `Disciple`,
  `Jesus`,
  `Mohamed`,
  `Mecca`,
  `Garden of Eden`,
  `Eid-Ul-Adha`,
  `Hymn`,
  `Usher`,
  `Ramadhan`,
  `Chrismas`,
  `Eid-Ul-Fitr`,
  `Guard Angel`,
  `Good Samaritan`,
  `Seer`,
  `Resurrect`,
  `Creed`,
  `Consecration`,
  `Devotion`,
  `Pilgrim`,
  `Sacrifice`,
  `Blasphemy`,
  `Sacred`,
  `Fasting`,
  `Celibacy`,
];

const regexp = new RegExp(`\\b(${DIAGEO_VIOLATED_WORDS.join(`|`)})\\b`, `ig`);

export const hasDiageoViolatedWords = (content) => {
  const words = (content.match(regexp) || []).map((word) => word.toLowerCase().trim());

  return words.length > MAX_VIOLATED_WORDS_COUNT;
};
